import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import { statusTypeStandardization } from 'utils/utils';
import { CircleGraphLabel, CriterionLine } from './CircleGraphLabel.css.js';
import { lineGraphReferenceValue } from 'utils/code';

const CircleGraph = (props) => {
  const colors = {
    'blue': {startColor: '#ABE5A1', endColor: '#0D7CBD'},
    'warning': {startColor: '#ffff07', endColor: '#ffa407'},
    'danger': {startColor: '#ff2807', endColor: '#ac07ff'},
  }

  const configSetter = () => { 
    return {
      options: {
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            offsetY: -10,
            hollow: {
              margin: 0,
              size: '60%',
              background: '#2F3B49',
              position: 'front',
            },
            track: {
              background: '#5A626F',
              strokeWidth: '100%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },
          }
        },
        fill: {
          colors: [colors[props.status].startColor],
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [colors[props.status].endColor],
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          //lineCap: 'round'
        },
        labels: [''],
      },
      series: [
        (props.dataValue - lineGraphReferenceValue[props.label].min) / (lineGraphReferenceValue[props.label].max - lineGraphReferenceValue[props.label].min) * 100
      ],
    };
  }

  const [ config, setConfig ] = useState(configSetter());

  useEffect(() => {
    setConfig(configSetter());
  }, [props])

  return (
    <>
      <CircleGraphLabel status={props.status}>
        {
          props.criterion.filter(x => x.standType !== 'criterion').map(data => {
            return (
              <CriterionLine key={data.standVal} standType={data.standType} value={(lineGraphReferenceValue[props.label].max - data.standVal) / (lineGraphReferenceValue[props.label].max - lineGraphReferenceValue[props.label].min)}>
                <span>{data.standName}</span> ▶
              </CriterionLine>
            )
          })
        }
        <div className="minValue">{ lineGraphReferenceValue[props.label].min }</div>
        <div className="circleLabel">{(props.moduleIdx === 118 || props.moduleIdx === 119 || props.moduleIdx === 120) ? '누액' : statusTypeStandardization(props.label)}</div>
        <div className="dataLabel">{props.dataValue}</div>
        <div className="maxValue">{ lineGraphReferenceValue[props.label].max }</div>
      </CircleGraphLabel>
      <Chart options={config.options} series={config.series} height={270} type="radialBar" />
    </>
  )
}

export default CircleGraph;

